module.exports = __webpack_public_path__ + "static/img/banner01.75d9340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/banner01.png
// module id = ikm+
// module chunks = 1